/**
 * Configuration loader.
 */
import { environment } from '../utils/environment'
import devConfig from './development.config.js'
import prodConfig from './production.config.js'
import stagingConfig from './staging.config.js'

const env = environment()

const getConfig = () => {
	if (env === 'production') {
		return prodConfig
	} else if (env === 'staging') {
		return stagingConfig
	}
	return devConfig
}

export default getConfig()
